import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';

function SurveysPage() {
  const { token } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(endpoints.surveys(), token).then(setData).catch(console.error).finally(() => setLoading(false));
  }, [token]);

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'userNombre', label: 'Usuario' },
    { key: 'feedback', label: 'Feedback', render: (v) => (v ? String(v).slice(0, 80) + '...' : '') },
    { key: 'createdAt', label: 'Fecha' },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Respuestas de encuestas</h1>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={data} emptyMessage="No hay respuestas" />}
    </div>
  );
}

export default SurveysPage;
